import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Destinations from './pages/Destinations';
import Attractions from './pages/Attractions';
import Tools from './pages/Tools';
import Guides from './pages/Guides';
import Deals from './pages/Deals';
import About from './pages/About';
import Contact from './pages/Contact';
import FirstTime from './pages/guides/FirstTime';
import Itineraries from './pages/guides/Itineraries';
import Transport from './pages/guides/Transport';
import TicketDeals from './pages/deals/TicketDeals';
import PassComparisons from './pages/deals/PassComparisons';

function App() {
  return (
    <Router>
      <div className="min-h-screen flex flex-col">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/destinations/*" element={<Destinations />} />
            <Route path="/attractions/*" element={<Attractions />} />
            <Route path="/tools/*" element={<Tools />} />
            <Route path="/guides" element={<Guides />} />
            <Route path="/guides/first-time" element={<FirstTime />} />
            <Route path="/guides/itineraries" element={<Itineraries />} />
            <Route path="/guides/transport" element={<Transport />} />
            <Route path="/deals" element={<Deals />} />
            <Route path="/deals/tickets" element={<TicketDeals />} />
            <Route path="/deals/passes" element={<PassComparisons />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
